/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";

import StoryCard11 from "../../../molecules/story-card11";
import { getCollection } from "../../../helper/api";

import "./more-news.m.css";
import Arrow from "../../../atoms/other-icons/Arrow";

const MoreNews = ({ story }) => {
  const storyReducer = useSelector((state) => get(state, ["storyReducer"], []));
  const makeSecondaryApiCalls = storyReducer.makeSecondaryApiCalls;
  const delay = storyReducer.delay;

  const [isVisible, setIsVisible] = useState(false);
  const [collection, setCollection] = useState([]);
  const ParentSectionUrl = story?.sections[0]["section-url"];
  const ParentCollectionSlug = story?.sections[0]?.collection?.slug;

  useEffect(() => {
    if (makeSecondaryApiCalls) {
      setTimeout(() => {
        if (ParentCollectionSlug) {
          getCollection(ParentCollectionSlug, 0, 4, story.id).then((collection) => setCollection(collection));
        }
      }, delay);
      setTimeout(() => setIsVisible(true), delay + 500);
    }
  }, [makeSecondaryApiCalls]);

  return (
    <div styleName="wrapper">
      {isVisible && (
        <>
          <div styleName="headline">
            <h1>ಇನ್ನಷ್ಟು ಸುದ್ದಿ</h1>
            {story && story.sections[0] && (
              <Link styleName="seemore" href={ParentSectionUrl && ParentSectionUrl}>
                ಇನ್ನಷ್ಟು
                <Arrow color="#b82831" width="16px" height="16px" />
              </Link>
            )}
          </div>
          <div styleName="stories">
            {collection &&
              collection.slice(0, 4).map((story, index) => (
                <div key={index}>
                  <StoryCard11 story={story} />
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MoreNews;
